<template>
      <TheFooter>
        <div>
          <!--footer-->
          <a href="http://spctc.cr/telecentinel/" target="_blank">SPC Telecentinel</a>
          <span class="ml-1">&copy; {{ currentYear }}</span>
        </div>
        <!--<div class="ml-auto">
          <span class="mr-1">Powered by</span>
          <a href="https://coreui.io">CoreUI for Vue</a>
        </div>-->
      </TheFooter>
</template>
<script>
import { Footer as TheFooter } from '@coreui/vue'
export default {
  name: 'DefaultFooter',
  data: function () {
    let currentDate = new Date();
    return {
      currentYear: currentDate.getFullYear()
    }
  },
  components: {
    TheFooter
  },
}
</script>
